import { render } from "./ProductSearchPicker.vue?vue&type=template&id=3edbf341&scoped=true"
import script from "./ProductSearchPicker.vue?vue&type=script&lang=js"
export * from "./ProductSearchPicker.vue?vue&type=script&lang=js"

import "./ProductSearchPicker.vue?vue&type=style&index=0&id=3edbf341&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edbf341"]])

export default __exports__